import Queue from '@/models/Queue';
import {ReportExportTypes} from "@/Types/ReportExportTypes";
import {FileType} from "@/Types/FileType";
import api from '../common/api/api';

export default class QueuesService {
    public async fetchQueues(scope: number | null = null): Promise<Queue[]> {
        let params = "";

        if (scope !== null) {
            params = `?scope=${scope}`
        }

        const response = await api.get(`/queues${params}`);

        const {data} = response.data;
        return data;
    }

    public async fetchQueue(uuid: string): Promise<Queue> {
        const response = await api.get(`/queues/${uuid}`);
        const {data} = response.data;
        return data;
    }

    public async fetchUserQueues(): Promise<Queue[]> {
        const response = await api.get(`/queues/users/me`);
        const {data} = response.data;
        return data;
    }

    public async addQueue(queue: Queue): Promise<Queue> {
        const response = await api.post(`/queues`, queue);
        const {data} = response.data;
        return data;
    }

    public async fetchReport(uuid: string, startDateUnix: number | null = null, endDateUnix: number | null = null): Promise<Queue> {
        let params: string = "";

        if (startDateUnix != null) {
            params += `startDate=${startDateUnix}`;
        }

        if (endDateUnix != null) {
            if (params.length > 0) {
                params += "&";
            }

            params += `endDate=${endDateUnix}`;
        }

        if (params.length > 0) {
            params = `?${params}`;
        }

        const response = await api.get(`/queues/${uuid}/report${params}`);
        const {data} = response.data;
        return data.queue;
    }

    public async downloadReport(uuid: string, type: ReportExportTypes, startDateUnix: number | null = null, endDateUnix: number | null = null): Promise<FileType> {
        let params: string = `type=${type}`;

        if (startDateUnix != null) {
            if (params.length > 0) {
                params += "&";
            }
            params += `startDate=${startDateUnix}`;
        }

        if (endDateUnix != null) {
            if (params.length > 0) {
                params += "&";
            }

            params += `endDate=${endDateUnix}`;
        }

        if (params.length > 0) {
            params = `?${params}`;
        }

        const response = await api.get(`/queues/${uuid}/report/export${params}`, {responseType: "arraybuffer"});

        const contentType = response.headers["content-type"].split(';')[0];
        const contentCharset = response.headers["content-type"].split('; ')[1].replace('charset=', '');
        const contentFileName = response.headers["content-disposition"].replace('attachment; filename=', '').split('.')[0];
        const contentFileExt = response.headers["content-disposition"].replace('attachment; filename=', '').split('.')[1];

        return {
            name: contentFileName,
            extension: contentFileExt,
            charset: contentCharset,
            type: contentType,
            file: new Blob([response.data], {type: response.headers["content-type"]})
        };
    }
}
